<template>
  <div>
    <div class="cont-x">
      <div class="table-x" ref="tableBox">
        <el-table
          v-loading="loading"
          :data="treeList"
          :height="tableHeight()"
          row-key="id"
          :cell-style="cellStyle"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          border
          class="mb20"
        >
          <el-table-column prop="qnId" align="center" label="问卷 ID">
          </el-table-column>
          <el-table-column prop="qnName" align="center" label="名称">
          </el-table-column>
          <el-table-column prop="countNum" align="center" label="使用人次">
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="toDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "evaluationList",
  components: {},
  data() {
    return {
      loading: false,
      treeList: [],
    };
  },
  methods: {
    /**
     * 查看
     */
    toDetail(item) {
      // this.$router.push({
      //   path: "/user/detail",
      //   query: {
      //     type: "record",
      //     // userId: "4134",
      //   },
      // });
      this.$router.push({
        path: "/user/user-management",
        query: {
          // type: "record",
          // userId: "4134",
        },
      });
    },
    tableHeight() {
      return Number(document.body.offsetHeight - 218);
    },
    getReceive(data) {
      this[data.key] = data.value;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1 && !row.children) {
        return {
          "border-right": "none",
        };
      }
    },
    getData() {
      this.loading = true;
      let params = {
        serviceId: 1,
      };
      this.axios
        .get(this.getApiUrlE("serviceList"))
        // .get(this.getApiUrlE("evaluationDetail"))
        // .get(this.getApiUrlE("evaluationDetail"))
        .then((res) => {
          if (res.code === 1) {
            this.treeList = res.data;
          } else {
            this.$message.warning(res.msg);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
  created() {
    this.$root.breadList = [
      { name: "问卷统计", link: "" },
      { name: "问卷列表", link: "" },
    ];
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/color.scss";
</style>
